export default __webpack_public_path__ + "svg/banner/intensive.svg?cfed09bb";